<template>
  <div>
    
    <div class="grid">
      <span></span><span></span><span style="font-size:14px;">Finansowanie</span><span style="font-size:14px;">Rejestracja po 01.2017</span>
      <span style="font-size:14px;">Szczegółowa selekcja</span><span style="font-size:14px;">Przyczyna dyskwalifikacji</span><span></span>
      <span>
        <button class='buttonRDTL' style='self-align:center;height:100%' @click="details=!details; idShow=0">
          <span v-if="!details">Widok szczegółowy</span><span v-else>Widok skrócony</span>
        </button>
      </span>
      <textarea style="height:65%; width:90%; " class="filtry category" v-model="filtry" @input="filtWpisy()"
        placeholder="Wyszukaj..."></textarea>
     <!-- <model-select :options="" v-model="icd10" class="selectUser border"
        :class="isFirefox()" style="min-width:100px; height:70%;" @input="filtruj()"></model-select> -->
        <span>
        <select  @change="filtruj()" v-model="finansowanie" style="height:80%; border-radius:3px;">
          <option value="">Wszystkie</option>
          <option value=true>Tak</option>
          <option value="false">Nie</option>
        </select>
        </span>
        <span>
        <select  @change="filtruj()" v-model="rejestracja" style="height:80%; width:100%;border-radius:3px;">
          <option value="">Wszystkie</option>
          <option value=true>Tak</option>
          <option value="false">Nie</option>
        </select>
        </span>
        <span>
        <select @change="filtruj()" v-model="selekcja" style="height:80%; width:100%;border-radius:3px;">
          <option value="">Wszystkie</option>
          <option value=true>Tak</option>
          <option value="false">Nie</option>
        </select>
        </span>
        <span>
        <select @change="filtruj()" v-model="przyczyna" style="height:80%; width:100%;border-radius:3px;">
          <option value="">Wszystkie</option>
          <option value="Rejestracja przed 01.01.2017">Rejestracja przed 01.01.2017</option>
          <option value="Status TLI">Status TLI</option>
          <option value="Finansowanie w Polsce">Finansowanie w Polsce</option>
          <option value="Oceniany w Agencji">Oceniany w Agencji</option>
          <option value="Inne">Inne</option>
        </select>
        </span>
       <!-- <model-select placeholder="substacja czynna" :options="activeSubstOptions" v-model="subs" :class="isFirefox()"
        class="selectUser border" style="min-width:100px; height:70%" @input="filtruj()" @searchchange="getSearchSub">
      </model-select>
      <model-select placeholder="nazwa handlowa" :options="tradeNameOptions" v-model="trade" :class="isFirefox()"
        class="selectUser border" style="min-width:100px; height:70%" @input="filtruj()" @searchchange="getSearchTrade">
      </model-select> -->
      
      <span class='tooltip' style="align-self:center; justify-self:center; z-index:999; padding-bottom:7px;">
        <!-- <font-awesome-icon icon="times" class='clickIconExit iconDelete' @click="clearFilters()" />
        <span class='tooltiptext'>Wyczyść filtry</span> -->
        <button type="button" class="buttonRDTL"  @click="clearFilters()">Wyczyść filtry</button>
      </span>
    </div>
    <br><br>
    <!-- <button type="button" class='buttonRDTL' @click="zalogowany=!zalogowany"><span v-if='zalogowany'>Niezalogowany</span>
    <span v-if='!zalogowany'>Zalogowany</span>
    </button> -->
    <span v-if="loaded">
      <vue-simple-spinner></vue-simple-spinner>
    </span>
    <div v-else>
      <div style="float:right;">Znaleziono {{entry.count}} elementów</div>
      <!-- <div> -->
      <table class="dataTable left-corner right-corner">
        <thead class="left-corner right-corner thColor">
          <tr class="left-corner right-corner">
            <th v-on:click="sort('lek');direction=!direction" class="sorting left-corner"
              v-bind:class="[{'leftText': details}]">Nazwa leku
              <div :class="checkArrow('lek')" style="float:right;">
              </div>
            </th>
            <th v-on:click="sort('subst_czynna');direction=!direction" class="sorting">Substancja czynna
              <div :class="checkArrow('subst_czynna')" style="float:right;">
              </div>
            </th>
            <!-- <th v-on:click="sort('icd_10');direction=!direction" class="sorting">Satus Orphan
              <div :class="checkArrow('icd_10')" style="float:right;">
              </div>
            </th> -->
            <th v-on:click="sort('wskazanie_oceniane');direction=!direction" class="sorting" :class="!isAuth ?'right-corner sorting':'sorting'">Wskazanie oceniane
              <div :class="checkArrow('wskazanie_oceniane')" style="float:right;">
              </div>
            </th>
            <!-- <th class=" " v-if="check()">BIP</th> -->
            <!-- <th class="sorting" v-if="check()" v-on:click="sort('nr_opinion');direction=!direction" >
             Postać farmaceutyczna
              <div :class="checkArrow('nr_opinion')" style="float:right;"></div>
            </th> -->
            <!-- <th class="sorting " v-if="check()" v-on:click="sort('show');direction=!direction" >
              Data dopuszczenia do obrotu EMA
            </th> -->
            <th class="right-corner" v-if="check()">Opcje</th>
          </tr>
        </thead>
        <tbody class="check" v-for="(wpis,ind) in entry.results" :key="ind+'O'">
          <tr class='rowChoice'>
            <td @click="SetIdShow(wpis.id)">{{wpis.lek}}</td>
            <td @click="SetIdShow(wpis.id)">{{wpis.subst_czynna}}</td>
            <!-- <td @click="SetIdShow(wpis.id)">{{DispStatus(wpis.status_orphan)}}</td> -->
            <td @click="SetIdShow(wpis.id)">{{wpis.wskazanie_oceniane}}</td>
            <!-- <td @click="SetIdShow(wpis.id)">{{wpis.postac_farmaceutyczna}}</td> -->
            <!-- <td @click="SetIdShow(wpis.id)">{{format_date(wpis.data_dopuszczenia)}}</td> -->
            <!-- <td @click="SetIdShow(wpis.id)" v-if="check()" style="text-align:center">
              <font-awesome-icon icon="check" class='clickIconExit' v-if='wpis.show'/>
              <font-awesome-icon icon="times" class='clickIconExit' v-else style='color:#9c3b3b;'/>
            </td> -->
            <td style="text-align:center" v-if="check()">
              <button class='buttonRDTL' type="button" @click='editEntry(wpis.id)' v-if="check()"
                style='margin-right: 10px;'>Edytuj</button>
              <!-- <button class='buttonRDTL' type="button" @click='downloadPDF(wpis)'>Pobierz pdf</button> -->
            </td>
          </tr>
          <tr v-if='wpis.id==idShow || details'>
            <td :colspan='returnCols()'>
              <table  class='viewTable'>
                <tr>
                  <td colspan='3' style="text-align:center;">Produkt leczniczy</td>
                </tr>
                <tr>
                  <td style="width:265px;">ID</td>
                  <td colspan="2">{{wpis.id}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Nazwa produktu leczniczego</td>
                  <td colspan="2">{{wpis.lek}}</td>
                </tr>
                 <tr>
                  <td style="width:265px;">Substancja czynna</td>
                  <td colspan="2">{{wpis.subst_czynna}}</td>
                </tr>
               
                  <tr>
                  <td >Kod Atc</td>
                  <td colspan="2">{{wpis.kod_atc}}</td>
                </tr> 
                <tr>
                  <td>Wskazania rejestracyjne</td>
                  <td colspan="2">{{wpis.wskazania_rejestracyjne}}</td>
                </tr>
                <tr>
                  <td>Wskazanie oceniane</td>
                  <td colspan="2">{{wpis.wskazanie_oceniane}}</td>
                </tr>
                <tr>
                  <td>Wiek</td>
                  <td colspan="2">{{(wpis.wiek)}}</td>
                </tr>
                <tr>
                  <td>Status Orphan</td>
                  <td colspan="2">{{DispStatus(wpis.status_orphan)}}</td>
                </tr>
                <tr>
                  <td>Stosowany w onkologii</td>
                  <td colspan="2">{{DispStatus(wpis.onkologia)}}</td>
                </tr>
                 <tr>
                  <td>Czy lek biopodobny</td>
                  <td colspan="2">{{DispStatus(wpis.biopodobny)}}</td>
                </tr>
                <tr>
                  <td >Czy lek generyczny</td>
                  <td colspan="2">{{DispStatus(wpis.genereczny)}}</td>
                </tr>
                <tr>
                  <td>Data dopuszczenia do obrotu EMA</td>
                  <td colspan="2">{{format_date(wpis.data_dopuszczenia)}}</td>
                </tr>
                <!-- tutaj -->
                <template v-if='temporaryFunc(wpis.id)'>
                <tr>
                  <td>Podmiot odpowiedzialny</td>
                  <td colspan="2">{{wpis.podmiot_odpowiedzialny}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Postać farmaceutyczna</td>
                  <td colspan="2">{{wpis.postac_farmaceutyczna}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Droga podania</td>
                  <td colspan="2">{{wpis.droga_podania}}</td>
                </tr>
                <tr>
                  <td>Dawkowanie leku</td>
                  <td colspan="2">{{wpis.dawkowanie}}</td>
                </tr>
                <tr>
                  <td>Schemat leczenia</td>
                  <td colspan="2">{{wpis.schemat_leczenia}}</td>
                </tr>
                <tr>
                  <td>Czas leczenia</td>
                  <td colspan="2">{{czasLeczenia[wpis.czas_lecznia]}}</td>
                </tr>
                <tr v-if="wpis.czas_lecznia == 'inny'">
                  <td >Czas leczenia - opis</td>
                  <td colspan="2">{{wpis.czas_leczenia_opis}}</td>
                </tr>
                <tr>
                  <td>Szczegółowe warunki stosowania</td>
                  <td colspan="2">{{wpis.warunki_stosowania}}</td>
                </tr>
                <tr>
                  <td>Badania diagnostyczne</td>
                  <td colspan="2">{{wpis.badania_diagnostycznie}}</td>
                </tr>
                 <tr>
                  <td>Badania przy kwalifikacji</td>
                  <td colspan="2">{{wpis.badania_kwalifikacja}}</td>
                </tr>
                 <tr>
                  <td>Badania przy monitorowaniu</td>
                  <td colspan="2">{{wpis.badania_monitorowanie}}</td>
                </tr>
                <tr>
                  <td>Komentarz</td>
                  <td colspan="2">{{wpis.komentarz_produkt}}</td>
                </tr>
                </template>
                <!-- tutaj koniec -->
                 <tr>
                  <td colspan='3' style="text-align:center;">Status leku</td>
                </tr>
                <template v-if="temporaryFunc(wpis.id)">
                  <!-- tutaj poczatek -->
                <tr >
                  <td rowspan="10">Podstawowa selekcja</td>
                   <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Czy rejestracja po 01.01.2017</td>
                  <td >{{DispStatus(wpis.rejestracja2017)}}</td>
                </tr> 
                 <tr>
                 <td style='background-color:white; border-bottom: 1px solid black; border-right: 1px solid black;' >Czy jest finansowany na podstawie Obwieszczenia MZ</td>
                  <td style="width:60%; ">{{DispStatus(wpis.finansowanie)}}</td>
                </tr>
                <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Komentarz do finansowania</td>
                  <td >{{wpis.finansowanie_komentarz}}</td>
                </tr>
                <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Czy spełnione kryteria oceny w ramach TLI</td>
                  <td >{{DispStatus(wpis.kryteria_TLI)}}</td>
                </tr>
                <!-- <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Czy lek biopodobny</td>
                  <td>{{DispStatus(wpis.biopodobny)}}</td>
                </tr>
                <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Czy lek generyczny</td>
                  <td>{{DispStatus(wpis.genereczny)}}</td>
                </tr> -->
                <!-- <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Typ badania</td>
                  <td>{{wpis.typ_badania}}</td>
                </tr> -->
                <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Czy dostępne badanie z grupą kontrolną</td>
                  <td>{{(wpis.badanie_grupakontrolna)}}</td>
                </tr>
                <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Czy dostępne badanie RCT</td>
                  <td>{{DispStatus(wpis.badanie_RTC)}}</td>
                </tr>
                <tr>
                  <td style="background-color:white; border-bottom: 1px solid black; border-right: 1px solid black;">Czy dostępne punkty końcowe związane z wyleczeniem</td>
                  <td>{{DispStatus(wpis.punkty_wyleczenie)}}</td>
                </tr>
                <tr>
                  <td style="background-color:white;  border-bottom: 1px solid black; border-right: 1px solid black;">Czy wynik istotny statystycznie</td>
                  <td>{{DispStatus(wpis.istotny_wyleczenie)}}</td>
                </tr>
                 <tr>
                  <td style="background-color:white; border-bottom: 1px solid black; border-right: 1px solid black;">Czy dostępne punkty końcowe związane z przeżyciem</td>
                  <td>{{DispStatus(wpis.punkty_przezycie)}}</td>
                </tr>
                <tr>
                  <td style="background-color:white; border-bottom: 1px solid black; border-right: 1px solid black;">Czy wynik istotny statystycznie</td>
                  <td>{{DispStatus(wpis.istotny_przezycie)}}</td>
                </tr>

                <tr >
                  <td rowspan="3">Dodatkowe informacje</td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' >Czy otrzymał ocenę Agencji</td>
                  <td style="width:60%; ">{{DispStatus(wpis.ocena_agencji)}}</td>
                </tr> 
                <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Wynik oceny Agencji</td>
                  <td >{{wpis.wynik_ocagencji}}</td>
                </tr>
                <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Czy otrzymał negatywną decyzję refundacyjną Ministra Zdrowia</td>
                  <td>{{DispStatus(wpis.negatywna_decyzja)}}</td>
                </tr>

                 <tr >
                  <td :rowspan="wpis.szczegolowa_selekcja ? 2:3">Podsumowanie podstawowej selekcji</td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' >Komentarz</td>
                  <td style="width:60%; ">{{(wpis.podstawowa_selekcjakom)}}</td>
                </tr> 
                <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Czy zakwalifikowany do szczegółowej selekcji</td>
                  <td >{{DispStatus(wpis.szczegolowa_selekcja)}}</td>
                </tr>
                <tr v-if="!wpis.szczegolowa_selekcja">
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Przyczyna dyskwalifikacji</td>
                  <td >{{(wpis.przyczyna_dyskwalifikacji)}}</td>
                </tr>

                <tr >
                  <td rowspan="3">Szczegółowa selekcja</td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' >Efekt zdrowotny - OS</td>
                  <td style="width:60%; ">{{(wpis.efekt_os)}}</td>
                </tr> 
                <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Efekt zdrowotny - Inny punkt końcowy</td>
                  <td >{{wpis.efekt_zdrowotny}}</td>
                </tr>
                <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Wartość LYG</td>
                  <td>{{(wpis.lyg)}}</td>
                </tr>
                
                <!-- <tr>
                  <td style="background-color:white; border-bottom: 1px solid black;border-right: 1px solid black;">Efekt kliniczny</td>
                  <td>{{wpis.efekt_kliniczny}}</td>
                </tr> -->
                <!-- <tr>
                  <td style="background-color:white; border-right: 1px solid black;">LYG</td>
                  <td>{{wpis.lyg}}</td>
                </tr> -->
                
                <tr>
                  <td>Podsumowanie szczegółowej selekcji</td>
                  <td colspan="2">{{(wpis.podsumowanie_selekcji_kom)}}</td>
                </tr></template>
                 <tr>
                  <td>Ocena Rady Przejrzystości</td>
                  <td colspan="2">{{(wpis.ocena_rady_przejrzystości)}}</td>
                </tr>
                <!-- <tr>
                  <td>Wynik kwalifikacji</td>
                  <td colspan="2">{{DispStatus(wpis.wynik_kwalifikacji)}}</td>
                </tr>
                <tr>
                  <td>Komentarz</td>
                  <td colspan="2">{{(wpis.komentarz_status)}}</td>
                </tr>-->
                <tr> 
                  <td>Czy ujęty w wykazie TLK</td>
                  <td colspan="2">{{DispStatus(wpis.status_tlk)}}</td>
                </tr>
                <!-- <tr>
                  <td colspan='3' style="text-align:center;">Produkt leczniczy</td>
                </tr>
                <tr>
                  <td style="width:265px;">Nazwa produktu leczniczego</td>
                  <td colspan="2">{{wpis.lek}}</td>
                </tr>
                 <tr>
                  <td style="width:265px;">Substancja czynna</td>
                  <td colspan="2">{{wpis.subst_czynna}}</td>
                </tr>
               <tr>
                  <td style="width:265px;">Postać farmaceutyczna</td>
                  <td colspan="2">{{wpis.postac_farmaceutyczna}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Droga podania</td>
                  <td colspan="2">{{wpis.droga_podania}}</td>
                </tr>
                  <tr>
                  <td >Kod Atc</td>
                  <td colspan="2">{{wpis.kod_atc}}</td>
                </tr> 
                <tr>
                  <td>Wskazania rejestracyjne</td>
                  <td colspan="2">{{wpis.wskazania_rejestracyjne}}</td>
                </tr>
                <tr>
                  <td>Wskazanie oceniane</td>
                  <td colspan="2">{{wpis.wskazanie_oceniane}}</td>
                </tr>
                <tr>
                  <td>Status Orphan</td>
                  <td colspan="2">{{wpis.status_orphan}}</td>
                </tr>
                <tr>
                  <td>Data dopuszczenia do obrotu EMA</td>
                  <td colspan="2">{{format_date(wpis.data_dopuszczenia)}}</td>
                </tr>
                <tr>
                  <td>Podmiot odpowiedzialny</td>
                  <td colspan="2">{{wpis.podmiot_odpowiedzialny}}</td>
                </tr>
                <tr>
                  <td>Dawkowanie leku</td>
                  <td colspan="2">{{wpis.dawkowanie}}</td>
                </tr>
                <tr>
                  <td>Schemat leczenia</td>
                  <td colspan="2">{{wpis.schemat_leczenia}}</td>
                </tr>
                <tr>
                  <td>Czas leczenia</td>
                  <td colspan="2">{{wpis.czas_lecznia}}</td>
                </tr>
                <tr v-if="wpis.czas_lecznia == 'inny'">
                  <td >Czas leczenia - opis</td>
                  <td colspan="2">{{wpis.czas_leczenia_opis}}</td>
                </tr>
                <tr>
                  <td>Szczegółowe warunki stosowania</td>
                  <td colspan="2">{{wpis.warunki_stosowania}}</td>
                </tr>
                <tr>
                  <td>Badania diagnostyczne</td>
                  <td colspan="2">{{wpis.badania_diagnostycznie}}</td>
                </tr>
                 <tr>
                  <td>Badania przy kwalifikacji</td>
                  <td colspan="2">{{wpis.badania_kwalifikacja}}</td>
                </tr>
                 <tr>
                  <td>Badania przy monitorowaniu</td>
                  <td colspan="2">{{wpis.badania_monitorowanie}}</td>
                </tr>
                <tr>
                  <td>Komentarz</td>
                  <td colspan="2">{{wpis.komentarz_produkt}}</td>
                </tr> -->
                <tr>
                  <td colspan='3' style="text-align:center;">Ocena niezaspokojonej potrzeby zdrowotnej</td>
                </tr>
                <!-- tutaj początek -->
                <template v-if="temporaryFunc(wpis.id)">
                 <tr >
                  <td rowspan="4">Problem zdrowotny</td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' >ICD-10</td>
                  <td style="width:60%; ">{{(wpis.icd_10)}}</td>
                </tr> 
                 <tr>
                  <td style="background-color:white;border-right: 1px solid black; border-bottom: 1px solid black;">Problem zdrowotny</td>
                  <td >{{wpis.problem_zdrowotny}}</td>
                </tr>
                <tr>
                  <td style="background-color:white;border-right: 1px solid black; border-bottom: 1px solid black;">Obszar terapeutyczny</td>
                  <td >{{wpis.obszar_terapeutyczny}}</td>
                </tr>
                 <tr>
                  <td style="background-color:white;border-right: 1px solid black; border-bottom: 1px solid black;">Komentarz</td>
                  <td >{{wpis.problem_zdrowotny_kom}}</td>
                </tr>
                </template>
                 <tr >
                  <td rowspan="11">Informacje o obciążeniu chorobowym (na podstawie GBD 2019) </td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' > Wskazanie dla DALY/YLL </td>
                  <td style="width:60%; ">{{(wpis.wskazanie_daly_yll)}}</td>
                </tr> 
                 <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">DALY (liczba bezwzględna)</td>
                  <td >{{wpis.daly_bezwzgledny}}</td>
                </tr>
                 <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">DALY/100 tys. (wsk. surowy)</td>
                  <td >{{wpis.daly_100}}</td>
                </tr>
                <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Analiza trendu wskaźnika DALY w latach 1990-2019</td>
                  <td colspan="3" style="text-align:center;"><img :src="wpis.daly_jpg" style="max-width:800px;"></td>
                </tr>
                 <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">YLL (liczba bezwzględna)</td>
                  <td >{{wpis.yll_bezwzgledny}}</td>
                </tr> <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">YLL/100 tys. (wsk. surowy)</td>
                  <td >{{wpis.yll_100}}</td>
                </tr>
                <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Analiza trendu wskaźnika YLL w latach 1990-2019 </td>
                  <td colspan="3" style="text-align:center;"><img :src="wpis.yyl_jpg" style="max-width:800px;"></td>
                </tr>
                 <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Współczynnik zapadalności (surowy)</td>
                  <td >{{wpis.zapadalnosc}}</td>
                </tr>
                 <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Współczynnik chorobowości (surowy)</td>
                  <td >{{wpis.chorobowosc}}</td>
                </tr>
                <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Wagi niesprawności</td>
                  <td colspan="3" style="text-align:center;"><img :src="wpis.tab_jpg" style="max-width:800px;"></td>
                </tr>
                 <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Komentarz</td>
                  <td >{{wpis.komentarz_epi}}</td>
                </tr>
                <!-- <tr>
                  <td>Analiza trendu wskaźnika DALY w latach 1990-2019</td>
                  <td colspan="3" style="text-align:center;"><img :src="wpis.daly_jpg" style="max-width:800px;"></td>
                </tr> -->

                <tr >
                  <td :rowspan="temporaryFunc(wpis.id)?3:2">Opcje alternatywne na podstawie EPAR</td>
                  <td style='background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;' >Opis z dokumentów EMA</td>
                  <td style="width:60%; ">{{(wpis.opis_ema)}}</td>
                </tr>
                 <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Komparator na podstawie EMA</td>
                  <td >{{wpis.komparator_ema}}</td>
                </tr> 
                <!-- tutaj poczatek -->
                <template v-if="temporaryFunc(wpis.id)">
                 <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Komentarz do opcji alternatywnych wg EMA</td>
                  <td >{{wpis.komentarz_ema}}</td>
                </tr> 
                </template>
                <!-- tutaj koniec -->

                 <!-- <tr >
                  <td :rowspan="1">Opcje alternatywne finansowane</td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' > Dostępność finansowanych opcji alternatywnycg wg Obwieszczenia MZ </td>
                  <td style="width:60%; ">{{DispStatus(wpis.dostepnosc_finansowania)}}</td>
                </tr> 
                <template v-for='(subs, indSub) in wpis.substancja_czynna' >
                <tr :key="indSub + 'sub1'">
                  <td rowspan='2'>Substancja czynna - {{indSub+1}}</td>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Nazwa finansowanej substancji czynnej wg Obwieszczenia MZ</td>
                  <td >{{subs.substancje_czynnne_mz}}</td>
                </tr>
                <tr :key="indSub + 'sub2'">
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black; background-color:white;' > Sposób finansowania wg Obwieszczenia MZ</td>
                  <td style="width:60%; ">{{subs.sposob_finansowanie}}</td>
                </tr> 
                </template>
              <tr>
                  <td > Komparator na podstawie opcji finansowych</td>
                  <td style="width:60%; " colspan="2">{{wpis.komparator}}</td>
                </tr> 
               <tr>
                  <td  >Komentarz</td>
                  <td style="width:60%; " colspan="2">{{wpis.komentarz_alter}}</td>
                </tr>  -->
                

                <!-- <tr >
                  <td :rowspan="dostepFinanse(wpis.dostepnosc_finansowania)">Opcje alternatywne finansowane</td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' > Dostępność finansowanych opcji alternatywnycg wg Obwieszczenia MZ </td>
                  <td style="width:60%; ">{{DispStatus(wpis.dostepnosc_finansowania)}}</td>
                </tr> 
                 <tr v-if="wpis.dostepnosc_finansowania">
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Finansowane substancje czynne wg Obwieszczenia MZ</td>
                  <td >{{wpis.substancje_czynnne_mz}}</td>
                </tr>
                 <tr v-if="wpis.dostepnosc_finansowania">
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Sposób finansowania wg Obwieszczenia MZ</td>
                  <td >{{wpis.sposob_finansowanie}}</td>
                </tr> <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;"> Komparator na podstawie opcji finansowych </td>
                  <td >{{wpis.komparator}}</td>
                </tr> <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Komentarz</td>
                  <td >{{wpis.komentarz_alter}}</td>
                </tr> -->

                 <!-- <tr >
                  <td :rowspan="dostepWytyczne(wpis.wytyczne_tl)"> Wytyczne kliniczne</td>
                  <td style='background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;' > Wytyczne kliniczne odnoszące się do ocenianej TL</td>
                  <td style="width:60%; ">{{DispStatus(wpis.wytyczne_tl)}}</td>
                </tr>  -->
                 <!-- <tr v-if="wpis.wytyczne_tl">
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Nazwa organizacji, skrót, rok, kraj/zasięg</td>
                  <td >{{wpis.nazwa_organizacji}}</td>
                </tr>
                <tr v-if="wpis.wytyczne_tl">
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Opis zaleceń </td>
                  <td >{{wpis.opis_zalecen}}</td>
                </tr>
                <tr v-if="wpis.wytyczne_tl">
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Siła rekomendacji i jakość dowodów</td>
                  <td >{{wpis.sila_rekomendacji}}</td>
                </tr> -->
                <!-- <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Komentarz</td>
                  <td >{{wpis.komentarz_kli}}</td>
                </tr> -->
                <!-- tutaj początek -->
                <template v-if="temporaryFunc(wpis.id)">
                <tr >
                  <td :rowspan="1">Opcje alternatywne na podstawie wytycznych klinicznych</td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' > Wytyczne kliniczne odnoszące się do ocenianego wskazania </td>
                  <td style="width:60%; ">{{DispStatus(wpis.wytyczne_kli_alt)}}</td>
                </tr> 
                <template v-for='(wytyczna, indWyt) in wpis.wytyczna_alter' >
                <tr :key="indWyt + 'wyt1'">
                  <td rowspan='1'>Wytyczna - {{indWyt+1}}</td>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Nazwa organizacji, skrót, rok, kraj/zasięg, link</td>
                  <td >{{wytyczna.nazwa_organizacji_alt}}</td>
                </tr>
                <!-- <tr :key="indWyt + 'wyt2'">
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black; background-color:white;' > Opis wytycznych</td>
                  <td style="width:60%; ">{{wytyczna.opis_wytycznych_alt}}</td>
                </tr>  -->
                </template>
                <tr>
                  <td > Podsumowanie wytycznych</td>
                  <td style="width:60%; " colspan="2">{{wpis.podsumowanie_wytyczne}}</td>
                </tr> 
               <tr>
              
                  <td > Komparator na podstawie wytycznych</td>
                  <td style="width:60%; " colspan="2">{{wpis.komparator_alt}}</td>
                </tr> 
               
                <tr>
                  <td > Czy wytyczne kliniczne odnoszą się do ocenianej TL</td>
                  <td style="width:60%; " colspan="2">{{DispStatus(wpis.odniesienie_tl)}}</td>
                </tr> 
                 <tr>
                  <td >Miejsce ocenianej technologii w wytycznych</td>
                  <td style="width:60%; " colspan="2">{{(wpis.miejsce_wytyczne)}}</td>
                </tr> 
               <tr>
                  <td  >Komentarz do wytycznych klinicznych</td>
                  <td style="width:60%; " colspan="2">{{wpis.komentarz_alt}}</td>
                </tr> 
                </template>
                <!-- tutaj koniec -->

                 <!-- <tr >
                  <td :rowspan="dostepWytyczneOpcje(wpis.wytyczne_kli_alt)"> Opcje alternatywne na podstawie wytycznych</td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' > Wytyczne kliniczne odnoszące się do ocenianego wskazania</td>
                  <td style="width:60%; ">{{DispStatus(wpis.wytyczne_kli_alt)}}</td>
                </tr> 
                 <tr v-if="wpis.wytyczne_kli_alt">
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Nazwa organizacji, skrót, rok, kraj/zasięg</td>
                  <td >{{wpis.nazwa_organizacji_alt}}</td>
                </tr>
                <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Komparator</td>
                  <td >{{wpis.komparator_alt}}</td>
                </tr>
                <tr>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Komentarz</td>
                  <td >{{wpis.komentarz_alt}}</td>
                </tr> -->
                 <tr >
                  <td :rowspan="1">Opcje alternatywne finansowane</td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' > Dostępność finansowanych opcji alternatywnycg wg Obwieszczenia MZ </td>
                  <td style="width:60%; ">{{DispStatus(wpis.dostepnosc_finansowania)}}</td>
                </tr> 
                <template v-for='(subs, indSub) in wpis.substancja_czynna' >
                <tr :key="indSub + 'sub1'">
                  <td rowspan='2'>Substancja czynna - {{indSub+1}}</td>
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Nazwa finansowanej substancji czynnej wg Obwieszczenia MZ</td>
                  <td >{{subs.substancje_czynnne_mz}}</td>
                </tr>
                <tr :key="indSub + 'sub2'">
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black; background-color:white;' > Sposób finansowania wg Obwieszczenia MZ</td>
                  <td style="width:60%; ">{{subs.sposob_finansowanie}}</td>
                </tr> 
                </template>
              <tr>
                  <td > Komparator na podstawie opcji finansowych</td>
                  <td style="width:60%; " colspan="2">{{wpis.komparator}}</td>
                </tr> 
               <tr>
                  <td  >Komentarz do opcji alternatywnych finansowanych </td>
                  <td style="width:60%; " colspan="2">{{wpis.komentarz_alter}}</td>
                </tr> 
                <tr>
                  <td> Podsumowanie oceny niezaspokojonej potrzeby zdrowotnej</td>
                  <td colspan="2">{{wpis.komentarz_podsumowanie}}</td>
                </tr>
                
               <!--  <tr>
                  <td>Podmiot odpowiedzialny</td>
                  <td>{{wpis.podmiot_odpowiedzialny}}</td>
                </tr>
                <tr>
                  <td>Dawkowanie</td>
                  <td>{{wpis.dawkowanie}}</td>
                </tr>
                <tr>
                  <td>Schemat Leczenia </td>
                  <td>{{wpis.schemat_leczenia}}</td>
                </tr>
                <tr>
                  <td>Czas leczenia</td>
                  <td>{{wpis.czas_lecznia}}</td>
                </tr>
                <tr>
                  <td>Warunki stosowania</td>
                  <td>{{wpis.warunki_stosowania}}</td>
                </tr>
                <tr>
                  <td>Badania diagnostyczne</td>
                  <td>{{wpis.badania_diagnostycznie}}</td>
                </tr>
                <tr>
                  <td>Komentarz</td>
                  <td>{{wpis.komentarz_produkt}}</td>
                </tr>-->
                <!-- <tr>
                  <td>Komentarz</td>
                  <td>{{wpis.komentarz_produkt}}</td>
                </tr>
               
                
               -->

                <!-- <tr>
                  <td style="width:265px;">Ogólny problem zdrowotny</td>
                  <td colspan="2">{{wpis.problem_zdrowotny}}</td>
                </tr>
                <tr>
                  <td>Opis ogólnego problemu zdrowotnego</td>
                  <td colspan="2">{{wpis.opis}}</td>
                </tr>
                <tr v-if="wpis.alternatywne_opcje">
                  <td>Alternatywne opcje refundowane w Polsce (wg obwieszczenia)</td>
                  <td colspan="2">{{wpis.alternatywne_text}}</td>
                </tr>
                <tr v-if="wpis.alternatywne_opcje">
                  <td>Aleternatywne opcje refundowane w Polsce - sposób fiansowania</td>
                  <td colspan="2" class='justify'>{{wpis.dostepnosc_finansowania}}</td>
                </tr> -->
                <tr>
                  <td colspan='3' style="text-align:center;">Ocena populacji docelowej</td>
                </tr>
                <tr>
                  <td style="width:265px;">Metodyka szacowania populacji</td>
                  <td colspan="2">{{wpis.metodyka_szacowania_populacji}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Wielkość populacji docelowej</td>
                  <td colspan="2">{{wpis.wielkosc_populacji_docelowej}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Wielkość populacji docelowej dolna granica</td>
                  <td colspan="2">{{wpis.wielkosc_populacji_docelowej_dolna_granica}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Wielkość populacji docelowej górna granica</td>
                  <td colspan="2">{{wpis.wielkosc_populacji_docelowej_gorna_granica}}</td>
                </tr>
                 <tr>
                  <td style="width:265px;">Przyrost populacji w skali roku</td>
                  <td colspan="2">{{wpis.przyrost_populacji_w_skali_roku}}</td>
                </tr>
                 <tr>
                  <td style="width:265px;">Źródła danych</td>
                  <td colspan="2">{{wpis.zrodla_danych}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Podsumowanie oceny populacji docelowej</td>
                  <td colspan="2">{{wpis.komentarz_oceny_populacji}}</td>
                </tr>
                <tr>
                  <td colspan='3' style="text-align:center;">Ocena siły interwencji</td>
                </tr>
                <!-- tutaj początek  -->
                <template v-if="temporaryFunc(wpis.id)">
                <tr>
                  <td colspan="7" style="background-color:#dae4f2;">
                    <template v-for="(badanie,index) in wpis.badanie" >
                      <table style="width:100%" v-bind:key="index+'bad'">
                      <tr>
                          <th colspan="3">Badanie {{index+1}}</th>
                      </tr>
                      <tr>
                        <td  style="width:15%">Nazwa badania</td>
                        <td colspan="2">{{badanie.nazwa}}</td>
                      </tr>
                      <tr>
                        <td style="width:20%">Ocena siły interwencji - typ badania</td>
                        <td colspan="2">{{badanie.typ}}</td>
                      </tr>
                      <tr>
                        <td rowspan="4">Charakterystyka badania</td>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;">Komparator z badania</td>
                        <td>{{badanie.komparator}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Okres obserwacji</td>
                        <td>{{badanie.okres_obserwacji}}</td>
                        <!-- <td>{{badanie.komparator}}</td> -->
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" > Okres leczenia</td>
                        <td>{{badanie.okres_lecznie}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" > Liczba pacjentów</td>
                        <td>{{badanie.liczba_pacjentow}}</td>
                      </tr>
                      <!-- <tr>
                        <td style="width:20%"> Ocena siły interwencji - komparator z badania
                        </td>
                        <td colspan="2">{{badanie.komparator}}</td>
                      </tr> -->

                      <template v-for="(punktKat,key) in badanie.punktkoncowy" >
                      <template v-for="(punkt,id) in punktKat" >
                        <tr v-bind:key="id + 'punkt'" v-if="id==0">
                          <td colspan="3" style="text-align:center;">
                            {{key}}
                          </td>
                        </tr>
                      <tr v-bind:key="id + 'punkt1'">
                        <td :rowspan="punkt.parametrstatystyczny.length*12 +3" style="width:20%">Punkt końcowy {{id+1}}</td><!-- tu było 6 -->
                        <td colspan="2" >{{punkt.nazwa}}</td>
                      </tr>
                      <tr v-bind:key="id + 'punkt2'">
                        <td style="background-color:#cbd4e1;" :style="isBorder(punkt.parametrstatystyczny.length)" colspan="2">{{typeDict[punkt.typ_punktu_końcowego]}}</td>
                      </tr>
                      <template v-for="(param,i) in punkt.parametrstatystyczny">
                        <tr  v-bind:key="i+'a'">

                        <td  style='width:30%'>Parametr statystyczny {{param.bezwzgledny}} {{i+1}}</td>
                        <!-- <td v-else style='width:30%'>Parametr statystyczny bezwzględny {{i+1}}</td> -->
                        <td >{{param.nazwa}}</td>
                        <!-- <td v-else>{{param.nazwa_bezwzgledne}}</td> -->
                        
                        </tr>
                        <tr  v-bind:key="i+'b'">
                        <td>Wartość</td>
                        <td>{{param.wartosc}}</td>
                        </tr>
                        <tr  v-bind:key="i+'c'">
                        <td> Przedział ufności (95%CI) - dolna granica</td>
                        <td>{{param.przedzial_dol}}</td>
                        </tr>
                        <tr  v-bind:key="i+'d'">
                        <td>Przedział ufności (95%CI) - górna granica </td>
                        <td>{{param.przedzial_gora}}</td>
                        </tr>
                        <tr  v-bind:key="i+'e'" >
                        <td >Wartość p</td>
                        <td >{{param.wartosc_p}}</td>
                        </tr>
                        <!-- nowe pola -->
                        <tr  v-bind:key="i+'e'" >
                        <td rowspan="3">Watość w ramieniu interwencji</td>
                        <td style="background-color:#dae4f2">Wartość: {{param.interwencja_wartosc}}</td>
                        </tr>
                       
                        <tr  v-bind:key="i+'e'" >
                          <td style="background-color:#dae4f2">Przedział ufności (95%CI) - dolna granica: {{param.interwencja_przedzial_dol}}</td>
                        </tr>
                        <tr  v-bind:key="i+'e'" >
                          <td style="background-color:#dae4f2">Przedział ufności (95%CI) - górna granica:  {{param.interwencja_przedzial_gora}}</td>
                        </tr>
                        
                        <tr  v-bind:key="i+'e'" >
                        <td rowspan="3">Watość w ramieniu komparatora</td>
                        <td style="background-color:#dae4f2;">Wartość: {{param.komparator_wartosc}}</td>
                        </tr>
                        
                        <tr  v-bind:key="i+'e'" >
                          <td style="background-color:#dae4f2">Przedział ufności (95%CI) - dolna granica: {{param.komparator_przedzial_dol}}</td>
                        </tr>
                        <tr  v-bind:key="i+'e'" >
                          <td style="background-color:#dae4f2">Przedział ufności (95%CI) - górna granica:  {{param.komparator_przedzial_gora}}</td></tr>
                          <!-- nowe pola -->
                        <tr  v-bind:key="i+'e'" >
                        <td :style='isLast(i,  punkt.parametrstatystyczny.length)'>Opis</td>
                        <td :style='isLast(i,  punkt.parametrstatystyczny.length)'>{{param.opis}}</td>
                        </tr>
                      </template>
                      <tr v-bind:key="id+ 'punkt3'">
                        <td style="background-color:#cbd4e1;"  colspan="2">{{punkt.komentarz_punkt_koncowy}}</td>
                      </tr>
                      </template>
                      </template>
                      <tr v-if="badanie.wykres_kaplana">
                        <td  style="width:15%">Wykres Kaplana-Mayera</td>
                        <td colspan="2" style="text-align:center;"><img :src="badanie.wykres_kaplana" style="max-width:800px;"></td>
                      </tr>
                      <tr v-if="badanie.wykres_kaplana">
                        <td  style="width:15%">Komentarz</td>
                        <td colspan="2">{{badanie.komentarz_wykres}}</td>
                      </tr>

                      <tr>
                        <td rowspan="4">Wartość LYG</td>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;">LYG/QUALYG w horyzoncie badania </td>
                        <td>{{badanie.LYG_QUALYG_w_horyzoncie_badania}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >LYG/QUALYG w horyzoncie rocznym</td>
                        <td>{{badanie.LYG_QUALYG_w_horyzoncie_rocznym}}</td>
                        <!-- <td>{{badanie.komparator}}</td> -->
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >LYG/QUALYG w horyzoncie dożywotnim</td>
                        <td>{{badanie.LYG_QUALYG_w_horyzoncie_dozywotnim}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Komentarz</td>
                        <td>{{badanie.komentarz_lyg}}</td>
                      </tr>

                      <tr>
                          <td colspan="3" style="text-align:center;">
                            Ograniczenia badania
                          </td>
                        </tr>
                       <tr >
                        <td  style="width:15%">Opis ograniczeń</td>
                        <td colspan="2">{{badanie.opis_ograniczen}}</td>
                      </tr>
                      <tr>
                          <td colspan="3" style="text-align:center;">
                            Dodatkowe informacje dot.
                          </td>
                        </tr>
                       <tr >
                        <td  style="width:15%">Komentarz</td>
                        <td colspan="2">{{badanie.komentarz_dodatkowe}}</td>
                      </tr>
                      <tr>
                          <td colspan="3" style="text-align:center;">
                            Ocena jakości badania
                          </td>
                        </tr>
                       <tr >
                        <td  style="width:15%">Skala oceny</td>
                        <td v-if="badanie.skala" colspan="2">Cochrane</td>
                        <td v-else-if="badanie.skala===false" colspan="2">NICE</td>
                      </tr>
                      <template v-if="badanie.skala">
                      <tr>
                        <td rowspan="7">Ocena ryzyka błędu systematycznego wg Cochrane RoB 2</td>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;">Randomizacja</td>
                        <td>{{badanie.randomizacja}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Ukrycie kodu alokacji</td>
                        <td>{{badanie.ukrycie_alokacji}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Zaślepienie badaczy i pacjentów</td>
                        <td>{{badanie.zaslepienie_badaczy}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Zaślepienie oceny wyników</td>
                        <td>{{badanie.zaslepienie_oceny}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Kompletność danych</td>
                        <td>{{badanie.kompletnosc_danych}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Selektywne raportowanie wyników</td>
                        <td>{{badanie.selektywne_raportowanie}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Inne czynniki</td>
                        <td>{{badanie.inne_czynniki}}</td>
                      </tr>
                      </template>

                      
                      <template v-else-if="badanie.skala===false">
                          <tr>
                        <td rowspan="8">Ocena wg skali NICE </td>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;"> Czy badanie było wieloośrodkowe?</td>
                        <td>{{DispStatus(badanie.wielosrodkowe)}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Czy cel (hipoteza) badania został jasno określony?</td>
                        <td>{{DispStatus(badanie.hipoteza)}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Czy kryteria włączenia i wykluczenia zostały jasno sformułowane?</td>
                        <td>{{DispStatus(badanie.wylaczenie_wyklucznie)}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Czy podano jasną definicję punktów końcowych?</td>
                        <td>{{DispStatus(badanie.jasna_def_punktu)}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" > Czy badanie było prospektywne?</td>
                        <td>{{DispStatus(badanie.prospektywne)}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Czy stwierdzono, że rekrutacja odbywała się w sposób konsekutywny?</td>
                        <td>{{DispStatus(badanie.konsekutywny)}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Czy jasno przedstawiono najważniejsze wyniki badania?</td>
                        <td>{{DispStatus(badanie.jasno_przedstawiono_wyniki)}}</td>
                      </tr>
                      <tr>
                        <td style="background-color:#dae4f2; border-bottom: 1px solid black; border-right: 1px solid black;" >Czy przeprowadzono analizę wyników w podgrupach?</td>
                        <td>{{DispStatus(badanie.podrupy)}}</td>
                      </tr>
                      </template>
                      <tr >
                        <td  style="width:15%">Wynik oceny</td>
                        <td colspan="2">{{badanie.wynik_oceny}}</td>
                      </tr>
                      <tr>
                          <td colspan="3" style="text-align:center;">
                           Podsumowanie siły interwencji
                          </td>
                        </tr>
                       <tr >
                        <td  style="width:15%">Komentarz</td>
                        <td colspan="2">{{badanie.podsumowanie_oceny_siły_interwencji}}</td>
                      </tr>

                      </table>
                    </template>
                  </td>
                </tr>
                <!-- tutaj koniec  -->
                </template>
                <tr>
                  <td  style="">Podsumowanie siły interwencji</td>
                  <td colspan="2">{{wpis.podusmowanie_sily_interencji}}</td>
                </tr>
                <!-- tutaj poczatek  -->
                <template v-if="temporaryFunc(wpis.id)">
                <tr>
                  <td colspan='3' style="text-align:center;">Ocena jakości dowodów naukowych</td>
                </tr>
                <tr>
                  <td style="width:265px;">Podsumowanie oceny jakości dowodów naukowych</td>
                  <td colspan="2">{{wpis.podsumowanie_oceny_naukowej}}</td>
                </tr>
                 <tr>
                  <td colspan='3' style="text-align:center;">Dodatkowe informacje na podstawie ChPL </td>
                </tr>
                <tr>
                  <td style="width:265px;">Działania niepożądane wg ChPL</td>
                  <td colspan="2">{{wpis.aes_z_chpl}}</td>
                </tr>
                <!-- <tr>
                  <td colspan='3' style="text-align:center;">Ocena populacji docelowej</td>
                </tr>
                <tr>
                  <td style="width:265px;">Metodyka szacowania populacji</td>
                  <td colspan="2">{{wpis.metodyka_szacowania_populacji}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Wielkość populacji docelowej</td>
                  <td colspan="2">{{wpis.wielkosc_populacji_docelowej}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Wielkość populacji docelowej dolna granica</td>
                  <td colspan="2">{{wpis.wielkosc_populacji_docelowej_dolna_granica}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Wielkość populacji docelowej górna granica</td>
                  <td colspan="2">{{wpis.wielkosc_populacji_docelowej_gorna_granica}}</td>
                </tr>
                 <tr>
                  <td style="width:265px;">Przyrost populacji w skali roku</td>
                  <td colspan="2">{{wpis.przyrost_populacji_w_skali_roku}}</td>
                </tr>
                 <tr>
                  <td style="width:265px;">Źródła danych</td>
                  <td colspan="2">{{wpis.zrodla_danych}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Podsumowanie oceny populacji docelowej</td>
                  <td colspan="2">{{wpis.komentarz_oceny_populacji}}</td>
                </tr> -->
                <!-- <tr>
                  <td colspan='3' style="text-align:center;">Ocena wpływu na budżet płatnika publicznego</td>
                </tr> -->
                <template v-if='isAuth'>
                 <tr>
                  <td colspan='3' style="text-align:center;">Ocena kosztów całkowitych</td>
                </tr>
               <tr >
                  <td rowspan="5">Populacja docelowa</td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' > Wielkość populacji docelowej w I roku</td>
                  <td style="width:60%; ">{{wpis.wielkosc_populacji_1rok}}</td>
                </tr> 
                 <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;"> Wielkość populacji docelowej w II roku</td>
                  <td >{{wpis.wielkosc_populacji_2rok}}</td>
                </tr>
              
                  <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;"> Wielkość populacji docelowej w okresie stabilnym</td>
                  <td >{{wpis.wielkosc_populacji_stabilna}}</td>
                </tr>
                <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Wielkość populacji docelowej w roku (średnia)</td>
                  <td >{{wpis.wielkosc_populacji_srednia}}</td>
                </tr>
                <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Komentarz</td>
                  <td >{{wpis.komentarz_populacji}}</td>
                </tr>
                <!-- <tr >
                  <td rowspan="2">Koszt terapii</td>
                  <td style='background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;' >  Koszt terapii [PLN]/pacjenta/rok </td>
                  <td style="width:60%; ">{{wpis.koszt_pacjenta_na_rok}}</td>
                </tr> 
                 <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;"> Całkowity koszt terapii[PLN]/rok</td>
                  <td >{{wpis.koszt_terapii_na_rok}}</td>
                </tr> -->
                <tr>
                  <td style="width:265px;">Perspektywa</td>
                  <td colspan="2">{{wpis.perspektywa}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Horyzont czasowy</td>
                  <td colspan="2">{{wpis.horyzont}}</td>
                </tr>

                <tr >
                  <td rowspan="6">Koszty</td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' >Cena leku</td>
                  <td style="width:60%; ">{{wpis.cena_leku}}</td>
                </tr> 
                 <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Dane dot. ceny leku</td>
                  <td >{{wpis.dane_dot_ceny}}</td>
                </tr>
              
                  <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Koszt leku na pacjenta</td>
                  <td >{{wpis.koszt_pacjenta_na_rok}}</td>
                </tr>
                <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Dodatkowe informacje dot. kosztów terapii</td>
                  <td >{{wpis.koszt_informacje}}</td>
                </tr>
                <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Dodatkowe koszty - opcjonalnie</td>
                  <td >{{wpis.dodatkowe_koszty}}</td>
                </tr>
                <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Komentarz</td>
                  <td >{{wpis.koszty_komentarz}}</td>
                </tr>
                <tr >
                  <td rowspan="4">Wyniki oszacowań</td>
                  <td style='border-bottom: 1px solid black; border-right: 1px solid black;' >Całkowity koszt leku w I roku</td>
                  <td style="width:60%; ">{{wpis.calkowity_koszt_1rok}}</td>
                </tr> 
                <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Całkowity koszt leku w II roku</td>
                  <td >{{wpis.calkowity_koszt_2rok}}</td>
                </tr>
                 <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Całkowity koszt leku w okresie stabilnym</td>
                  <td >{{wpis.calkowity_koszt_stabilny}}</td>
                </tr>
                 <tr >
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Całkowity średni roczny koszt leku </td>
                  <td >{{wpis.calkowity_koszt_sredni}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Podsumowanie oceny kosztów całkowitych</td>
                  <td colspan="2">{{wpis.komentarz_wplywu_na_budzet}}</td>
                </tr>
                <!-- <tr>
                  <td colspan='3' style="text-align:center;">Ocena farmakologiczna</td>
                </tr>
                <tr>
                  <td style="width:265px;"> LYG/QUALYG w horyzoncie badania</td>
                  <td colspan="2">{{wpis.LYG_QUALYG_w_horyzoncie_badania}}</td>
                </tr>
               <tr>
                  <td style="width:265px;"> LYG/QUALYG w horyzoncie rocznym</td>
                  <td colspan="2">{{wpis.LYG_QUALYG_w_horyzoncie_rocznym}}</td>
                </tr><tr>
                  <td style="width:265px;"> LYG/QUALYG w horyzoncie dożywotnim</td>
                  <td colspan="2">{{wpis.LYG_QUALYG_w_horyzoncie_dozywotnim}}</td>
                </tr><tr>
                  <td style="width:265px;"> ICUR/ICER w horyzoncie badania [PLN/LYG]</td>
                  <td colspan="2">{{wpis.ICUR_ICER_w_horyzoncie_badania}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">  ICUR/ICER w horyzoncie rocznym [PLN/LYG]</td>
                  <td colspan="2">{{wpis.ICUR_ICER_w_horyzoncie_rocznym}}</td>
                </tr>
                 <tr>
                  <td style="width:265px;">  ICUR/ICER w horyzoncie dożywotnim [PLN/LYG]</td>
                  <td colspan="2">{{wpis.ICUR_ICER_w_horyzoncie_dozywotnim}}</td>
                </tr> -->
                </template>
                 <tr>
                  <td colspan='3' style="text-align:center;">Zagraniczne rekomendacje refundacyjne</td>
                </tr>
                <tr>
                  <td style="width:265px;"> Wynik wyszukiwania</td>
                  <td colspan="2">{{DispStatus(wpis.wynik_wyszukiwania)}}</td>
                </tr>
                
                <template v-for="(instytucja, indexIn) in wpis.instytucja" >
                <tr :key="indexIn+'in'">
                  <td rowspan="3">Rekomendacja - {{indexIn+1}}</td>
                  <td style='background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;' >Nazwa instytucji, rok, zasięg/kraj, link</td>
                  <td style="width:60%; ">{{instytucja.nazwa_instytucji}}</td>
                </tr> 
                 <tr :key="indexIn +'in4'">
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Wynik oceny</td>
                  <td >{{opiniaDict[instytucja.wynik_oceny]}}</td>
                </tr>
                <tr :key="indexIn +'in5'">
                  <td style="background-color:white;border-bottom: 1px solid black; border-right: 1px solid black;">Komentarz - podsumowanie rekomendacji refundacyjnych</td>
                  <td >{{instytucja.uzasadnienie_oceny}}</td>
                </tr>
                </template>
                <!-- <tr>
                  <td style="width:265px;"> Nazwa instytucji, rok, zasięg/kraj</td>
                  <td colspan="2">{{wpis.nazwa_instytucji}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Wynik oceny</td>
                  <td colspan="2">{{wpis.wynik_oceny}}</td>
                </tr>
                <tr>
                  <td style="width:265px;">Uzasadnienie oceny </td>
                  <td colspan="2">{{wpis.uzasadnienie_oceny}}</td>
                </tr>-->
                <tr> 
                  <td colspan='3' style="text-align:center;">Ocena niepewności wnioskowania</td>
                </tr>
                <tr>
                  <td style="width:265px;">Komentarz</td>
                  <td colspan="2">{{wpis.ocena_niepewnosci}}</td>
                </tr>

                <tr>
                  <td colspan='3' style="text-align:center;">Dodatkowe informacje</td>
                </tr>
                <tr>
                  <td style="width:265px;">Komentarz</td>
                  <td colspan="2">{{wpis.dodatkowe_inofrmacje}}</td>
                </tr>
                <!-- tutaj koniec  -->
                </template>
                <tr>
                  <td colspan='3' style="text-align:center;">Źródła danych (linki)/Bibilografia</td>
                </tr>
                <tr>
                  <td style="width:265px;">strona EMA</td>
                  <td colspan="2"><a class='link' :href='wpis.chpl' target='_blank'>{{wpis.chpl}}</a></td>
                </tr>
                <!-- <tr>
                  <td style="width:265px;">EPAR</td>
                  <td colspan="2"><a class='link' :href='wpis.epar' target='_blank'>{{wpis.epar}}</a></td>
                </tr> -->
                <tr>
                  <td style="width:265px;">Badanie rejestracyjne</td>
                  <td colspan="2">
                    <a v-for='(badanieRej, index) in wpis.badania_rejestracyjne' :key='"br"+index' class='link' :href='badanieRej' target='_blank'>{{badanieRej}}<br></a>
                  </td>
                </tr>
                <!-- <tr>
                  <td>Wytyczne</td>
                  <td class='justify'>
                    <span v-for="(guide,ind1) in wpis.entryguid" :key="ind1">
                      <a class="link" @click="getFile(guide.guide_url)">{{guide.full_guide_name}}</a>
                      <br>
                    </span>
                  </td>
                </tr> -->
                
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      <div style='font-size:10px;text-align:center; width:100%'>
        <button class='buttonRDTL' @click="prevPage()" v-show='entry.previous'>&#60;</button>&nbsp;
        <span v-if='entry.previous || entry.next'
          style='font-size:12px;text-align:center; width:100%'>{{currentPage}}/{{Math.ceil(entry.count/30)}}</span>&nbsp;
        <button class='buttonRDTL' @click="nextPage()" v-show='entry.next'>&#62;</button>
      </div>
    </div>

    <modal name="editWarning" styles="padding: 40px;" :width='450' :height='200' v-if='edytowane.length'>
      <div style='text-align:center'>
        <div>
          Wpis jest aktualnie edytowany przez <strong>{{edytowane[0].full_name}}</strong>. 
          Skontaktuj się z użytkownikiem i&nbsp;poproś o&nbsp;zakończenie edycji, jeśli chcesz wprowadzić zmiany.
        </div><br>
        <span>
        <!-- <button type="button" @click="deleteItem(deleteIndex.item)" class='buttonRDTL'>Tak</button> -->
        <button type="button" @click="$modal.hide('editWarning')" class='buttonRDTL'>Zamknij</button>
        </span>
      </div>
    </modal>
    <go-top bg-color="#004b8b" :size='50'></go-top>

  </div>
</template>

<script>
import axios from "axios";
import GoTop from "@inotom/vue-go-top";
import { mapState, mapActions } from "vuex";
import Spinner from "vue-simple-spinner";
import { ModelSelect } from "vue-search-select";
import moment from "moment";
import auth from "../auth";
import Vue from 'vue'

export default {
  name: "Home",
  computed: {
    ...mapState({
      edytowane: (state) => state.edytowane.edytowane,
      entry: (state) => state.entry.entry,
      CurrentUser: state => state.CurrentUser.CurrentUser,
    }),
  },
  data() {
    return {
      zalogowany: true,
      details: false,
      idShow: null,
      filtry: "",
      loaded: true,//false
      currentPage: 1,
      isAuth: false,
      nameSort: "",
      direction: true, //true rosnąco, flase malejąco
      icd10List: [],
      icd10: "",
      activeSubstOptions: [],
      tradeNameOptions: [],
      searchTrade: "",
      searchSub: "",
      searchICD10: "",
      trade: "",
      subs: "",
      typeDict:{
        'pierwszorzędowy': 'Pierwszorzędowy',
        'drugorzędowy': 'Drugorzędowy',
        'inny': 'inny'
      },
      opiniaDict:{
        'pos': 'pozytywna',
        'posvar':'pozytywna warunkowa',
        'neg':'negatywna',
        'neu':'neutralna',
        'in':'w trakcie',
        'out':'odstąpiono od oceny'
      }, 
      czasLeczenia:{
        'tcia': 'terapia ciągła',
        'tjed': 'terapia jednorazowa',
        'inny': 'inny'
      },
      finansowanie:"",
      rejestracja:"",
      selekcja:"",
      przyczyna:""
    };
  },
  methods: {
    ...mapActions("entry", ["getEntry"]),
    ...mapActions("edytowane", ["getEdytowane", "deleteEdytowane"]),
    detailedView(flag) {
      this.details = flag;
      this.idShow = 0;
    },
    getFile(file) {
      let fileURL = file;
      window.open(fileURL, "_blank");
    },
    filename(file) {
      return file.files.split("/").slice(-1)[0];
    },
    SetIdShow(id) {
      if ((this.idShow > 0 && this.idShow === id) || this.details) {
        this.idShow = 0;
      } else {
        this.idShow = id;
      }
    },
    format_date(value) {
      if (value === "1900-01-01" || !value) {
        return "---";
      } else {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
    format_date_hour(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY HH:mm");
      }
    },
    clearFilters() {
      (this.filtry = "");
      (this.direction = true), (this.nameSort = ""); this.rejestracja="", this.selekcja="",this.finansowanie="", this.przyczyna=""
      this.idShow = 0;
      this.filtruj();
    },
    editEntry(id) {
      let params = {'id_wpis': id}
      this.getEdytowane({params}).then(response =>{
        if(response.length){
          if(response[0].Uid==this.CurrentUser[0].id){ //shouldn't happen but...
            params = {id_wpis: id}
            this.deleteEdytowane({params}).then(()=>{
              Vue.prototype.$editId = id
              this.$router.push({ path: "/form" })
            })
          }else{
            this.$modal.show('editWarning')
          }
        }else{
          Vue.prototype.$editId = id
          this.$router.push({ path: "/form" });
        }
      })
    },
    close() {
      this.$emit("close");
    },
    forceFileDownload(response, id, title) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${id}_${title}.pdf`); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    downloadPDF(wpis) {
      let title =
        wpis.name_trade +
        " - " +
        wpis.name_substance +
        " [" +
        wpis.icd_10 +
        "]";
      axios({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT2 + `pdf/?id_pdf=${wpis.id}`,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, wpis.id, title);
        })
        .catch(() => console.log("error occured"));
    },
    filtWpisy() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.filtruj();
      }, 500);
    },
    howMany() {
      this.pageSize = 30;
      this.pageQuantity = Math.ceil(this.wpisy.count / this.pageSize);
      return this.pageQuantity;
    },
    nextPage() {
      let link = this.entry.next.split("?")[1].split("&");
      let params = new URLSearchParams();

      link.forEach((item) => {
        let a = item.split("=");
        a[1] = a[1].replace(/\+/g, " ");
        a[1] = a[1].replace(/%2C/g, ",");
        params.append(a[0], a[1]);
      });
      for (var pair of params.entries()) {
        console.log(pair[0] + ", " + pair[1]);
      }

      this.$store.dispatch("entry/RESET_MODULE");
      this.loaded = true;
      this.getEntry({ params })
        .then((response) => {
          if (response) {
            this.loaded = false;
          }
        })
        .catch((err) => {
          console.log(err.response.status);
          {
            this.loaded = false;
          }
        });
      this.currentPage = params.get("page");
    },
    prevPage() {
      let link;
      let params;
      if (this.currentPage == 2) {
        if (this.entry.previous.split("?").length > 1) {
          link = this.entry.previous.split("?")[1].split("&");
          params = new URLSearchParams();

          link.forEach((item) => {
            let a = item.split("=");
            a[1] = a[1].replace(/\+/g, " ");
            a[1] = a[1].replace(/%2C/g, ",");
            params.append(a[0], a[1]);
          });
        } else {
          params = {};
        }
        this.$store.dispatch("entry/RESET_MODULE");
        this.loaded = true;
        this.getEntry({ params })
          .then((response) => {
            if (response) {
              this.loaded = false;
            }
          })
          .catch((err) => {
            console.log(err.response.status);
            {
              this.loaded = false;
            }
          });
        this.currentPage = 1;
        return 0;
      } else link = this.entry.previous.split("?")[1].split("&");
      params = new URLSearchParams();

      link.forEach((item) => {
        let a = item.split("=");
        a[1] = a[1].replace(/\+/g, " ");
        a[1] = a[1].replace(/%2C/g, ",");
        params.append(a[0], a[1]);
      });
      this.$store.dispatch("entry/RESET_MODULE");
      this.loaded = true;
      this.getEntry({ params })
        .then((response) => {
          if (response) {
            this.loaded = false;
          }
        })
        .catch((err) => {
          console.log(err.response.status);
          {
            this.loaded = false;
          }
        });
      if (!params.get("page")) {
        this.currentPage = 1;
      } else {
        this.currentPage = params.get("page");
      }
    },
    check() {
      return auth.user.authenticated
      // return this.zalogowany;
    },
    sort(name) {
      if (this.direction) {
        this.nameSort = name;
      } else {
        this.nameSort = "-" + name;
      }
      this.filtruj();
    },
    filtruj() {
      let filter = [];
      filter = this.filtry.split(",").map(function(item) {
        return item.trim();
      });
      filter = filter.join(",");
      let params = {
        ordering: this.nameSort,
        search: filter,
        size:30,
        page:1,
        is_selekcja:this.selekcja,
        is_finansowanie:this.finansowanie,
        is_rejestracja:this.rejestracja,
        is_przyczyna: this.przyczyna
       
      };
      // if (!this.subs) {
      //   params["name_substance"] = this.searchSub;
      //   // if(!this.subs){params['name_substance']=this.searchSub
      //   // if(!this.subs){params['name_substance']=this.searchSub
      // }
      this.$store.dispatch("entry/RESET_MODULE");
      this.loaded = true;
      this.getEntry({ params })
        .then((response) => {
          // console.log(JSON.stringify(response))
          if (response) {
            this.loaded = false;
          }
        })
        .catch((err) => {
          console.log(err.response.status);
          {
            this.loaded = false;
          }
        });
    },
    checkArrow(name) {
      if (this.nameSort.replace("-", "") != name) {
        return "arrow-none";
      } //usunąć - i porównać
      else {
        return this.direction ? "arrow-up" : "arrow-down";
      }
    },
    getSelectData() {
      //   let icd10_f = ["C90.0", "C92.1", "C18.3"];
      //   let handl_f = ["Darzalex", "Iclusig", "Lonsurf"];
      //   let subst_f = ["daratumumab", "ponatinib", "blinatumomab"];

      this.tradeName.forEach((item, ind) => {
        this.tradeNameOptions.push({ value: item, text: item + " " });
      });

      this.activeSubst.forEach((item, ind) => {
        this.activeSubstOptions.push({ value: item, text: item + " " });
      });

      this.icd10Table.forEach((item, ind) => {
        this.icd10List.push({ value: item, text: item + " " });
      });
    },
    getSearchText(txt) {
      this.searchICD10 = txt;
      // this.filtruj()
    },
    getSearchTrade(txt) {
      this.searchTrade = txt;
      // this.filtruj()
    },
    getSearchSub(txt) {
      this.searchSub = txt;
      // this.subs=txt
      this.filtWpisy();
    },
    isFirefox() {
      console.log(this.$browserDetect.isFirefox);
      if (this.$browserDetect.isFirefox) {
        return "";
      } else return "notFF";
    },
    returnCols() {
      if (this.check()) {
        return 8;
      } else return 5;
    },
    DispStatus(status){
      if(status===null) return "Nie odnaleziono"
      if(status) return "TAK"
      return 'NIE'
    },
    isBorder(num){
        if(num!=0) {return 'border-bottom: 1px solid black;'}
    },
    isLast(i,lenOf){
      if ((i+1)!=lenOf)  {return 'border-bottom: 1px solid black;'}

    },
    dostepFinanse(flag){
      if(flag) return '5'
      else return '3'
    },
    dostepWytyczne(flag){
      if(flag) return '5'
      else return '2'
    },
    dostepWytyczneOpcje(flag){
      if(flag) return '4'
      else return '3'
    },
    temporaryFunc(id){
      let indexes = [358,382,410,411,230,1210,1211,242,243,24,568,696,970,1309,49,68,102,120,139,156,173,207,572,393,398,593,788,800,806,812,1041,1042,1205,1206,415]
      if(indexes.includes(id) || this.isAuth) {return true} 
      else { return false}
    }
  },
  created() {
    Vue.prototype.$editId = 0
    this.$store.dispatch("entry/RESET_MODULE");
    this.loaded = true;
    let params ={size:30, page:1}
    this.getEntry({params})
      .then((response) => {
        if (response) {
          this.loaded = false;
        }
      })
      .catch((err) => {
        console.log(err.response.status);
        {
          this.loaded = false;
        }
      });
    this.isAuth = auth.checkAuth();
    // this.getSelectData();
  },
  components: {
    ModelSelect,
    Spinner,
    GoTop,
  },
}; //created nie jest metodą, a mapAction potrzebuje ...mapAction
</script>

<style>
.chosenTag {
  background-color: rgb(241, 190, 95);
}

.adnotacja {
  font-size: 12px;
  color: rgb(121, 121, 121);
  font-style: italic;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  /* justify-content: center;
    align-items: center; */
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.insidePop {
  height: 100%;
  display: grid;
  align-items: center;
  justify-items: center;
}

.popButtons {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.secondfilterrow {
  width: 100%;
  display: inline-grid;
  grid-template-columns: auto auto auto;
  /* 2fr 2fr 3fr 2fr; */
  align-items: center;
  /* justify-items:center; */
}

.secondfilterrow button {
  margin: 0px;
  font-size: 14px;
  padding: 8px;
}

.thirdfilterrow {
  display: inline-block;
  padding-top: 10px;
  text-align: left;
  width: 100%;
}

.thirdfilterrow span {
  padding-right: 10px;
}

.lista1 {
  display: inline-grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 10px;
  align-items: center;
}

.first {
  align-self: start;
  justify-self: start;
}

.last {
  align-self: end;
  justify-self: end;
}

.tagi100 {
  display: grid;
  grid-template-columns: 1fr 6fr 2fr;
  justify-items: center;
  border-bottom: 1px dotted rgb(172, 167, 167);
  padding-bottom: 2px;
  padding-top: 2px;
  cursor: pointer;
}

.flow {
  word-break: break-all;
}

.category {
  border-radius: 5px !important;
  border: 2px solid #004b8b !important;
  padding-left: 10px;
  /* width: 80%; */
}

.category:focus {
  border-color: #96c8da !important;
  border-radius: 5px;
  outline: none;
}

.widerPub {
  width: 90% !important;
}

.no-margin {
  margin: 0px;
}

.wpis-title {
  text-align: left;
  padding-left: 5px;
}

.filtry {
  /* width: 80%; */
  border-radius: 6px;
  height: 50%;
  resize: none;
  width: 90%;
}

.numer {
  border-radius: 6px;
  width: 90%;
  height: 40%;
}

.sortDetails {
  width: 40%;
  display: grid;
  grid-template-columns: 1fr 3fr 0.5fr;
  grid-column-gap: 0px;
  float: right;
}

.view button {
  /* padding: 4px; */
  background-color: #c3e5e7;
  color: rgb(90, 86, 86);
}

.toRight {
  margin-left: 50%;
}

.lista {
  /* border: solid 2px black; */
  border-radius: 6px;
  padding: 10px;
  background-color: rgba(29, 38, 65, 0.795);
  margin: 0px;
  /* box-shadow: -5px -10px 10px #1a2a4b; */
  font-size: medium !important;
  color: black !important;
  text-align: left;
}

.wpisy2 {
  width: 100%;
}

.details {
  border-radius: 3px;
  padding: 5px;
  background-color: rgba(223, 229, 247, 0.795);
  margin: 0px;
  /* box-shadow: -5px -10px 10px #1a2a4b; */
  font-size: medium !important;
  color: rgb(53, 52, 52) !important;
  text-align: left;
}

p {
  font-size: medium !important;
  color: #2c3e50 !important;
}

.paging {
  float: right;
}

.chooseHowMany2 {
  margin-left: 80%;
}

.pageSize2 {
  /* box-shadow: 3px 4px 5px 0px #899599;
	background:linear-gradient(to bottom, #ededed 5%, #bab1ba 100%);*/
  background-color: #c6e7e6;
  cursor: pointer;
  color: #244042;
  font-family: Georgia;
  /* font-family: Arial; */
  font-size: 15px;
  padding: 0px;
  text-decoration: none;
  margin: 0px;
  font-weight: 100;
}

.pageSize2:hover {
  text-decoration: underline;
}

.pageSize2:active {
  position: relative;
  top: 1px;
}

.choose {
  text-align: left;
}

.dataTable {
  display: block;
  width: 100%;
  margin: 1em 0;
}

.dataTable thead,
.dataTable tbody,
.dataTable thead tr,
.dataTable th {
  display: block;
}

.check:hover {
  background-color: #d1cccc;
}

.dataTable thead {
  float: left;
}

.dataTable tbody {
  width: auto;
  position: relative;
  overflow-x: auto;
}

.dataTable p,
.dataTable th {
  padding: 0.645em;
  line-height: 1.5em;
  border-bottom: 1px dashed #ccc;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
}

.dataTable th {
  text-align: center;
  /* background: rgba(0, 0, 0, 0.14); */
  border-bottom: 1px dashed #aaa;
}

.dataTable .rightText {
  text-align: right;
  padding-right: 5%;
}

.dataTable .leftText {
  text-align: left;
  padding-left: 1.2%;
  width: 20%;
}

.dataTable tbody tr {
  display: table-cell;
}

.dataTable tbody p {
  display: block;
}

.dataTable tbody tr:nth-child(odd) {
  background: rgba(0, 0, 0, 0.07);
}

@media screen and (min-width: 50em) {
  .dataTable {
    display: table;
  }

  .dataTable thead {
    display: table-header-group;
    float: none;
  }

  .dataTable tbody {
    display: table-row-group;
  }

  .dataTable thead tr,
  .dataTable tbody tr {
    display: table-row;
  }

  .dataTable th,
  .dataTable tbody p {
    display: table-cell;
  }

  td {
    padding: 1px 1px 1px 3px;
  }

  .left-corner {
    border-top-left-radius: 20px;
  }

  .right-corner {
    border-top-right-radius: 20px;
  }

  .tableHeader {
    background-color: #004b8b;
    color: white;
  }

  .thColor th {
    background-color: #004b8b;
    color: white;
  }

  .dataTable p,
  .dataTable th {
    width: auto;
  }

  .selects {
    margin: 10px;
    border: none;
    border-radius: 0.3em;
    background: #eee;
  }

  .edit {
    border: none;
    background: none;
    color: black;
    padding: 0px;
    text-decoration: underline;
  }
}

th.sorting {
  cursor: pointer;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;

  border-bottom: 5px solid black;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;

  border-top: 5px solid black;
}

.arrow-none {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;

  border-top: 5px solid transparent;
}

.moveItToRight {
  text-align: right;
  width: 98%;
}

.viewTable {
  width: 99%;
  margin: 0px;
  text-align: left;
}

.filter {
  display: grid;
  grid-template-columns: 1fr 5fr 5fr 5fr 2fr 2.2fr 1fr;
  /* grid-template-columns: auto auto auto auto auto auto; */
  margin-bottom: 5px;
  grid-column-gap: 10px;
  align-items: start;
}

.filterGuest {
  display: grid;
  grid-template-columns: 1fr 5fr 6.1fr 6.1fr 2fr 1fr;
  /* grid-template-columns: auto auto auto auto auto auto; */
  margin-bottom: 5px;
  grid-column-gap: 10px;
  align-items: start;
}

.filter div:last-child,
.filterGuest div:last-child {
  /* align-self: center; */
}

/* .thirdRow{
    display: grid;
    grid-template-columns: auto auto auto;
    justify-items: center;
  }
  .thirdRow div:last-child{
    justify-self: end;
  }
   .thirdRow div:first-child{
    justify-self: start;
  } */
.nomargin div button,
.margintop {
  margin: 0px;
  margin-top: 5px;
}

/* tabelka podgladu w pop upie (row, column, left, right, f)*/
.viewTable {
  /* margin: 10px; */
  width: 100%;
  /* border: 1px solid #868686; */
  background: white;
}

.row {
  width: 100%;
}

.left {
  width: 20%;
  background: #e1f3f2e7;
  padding: 5px;
  padding-left: 10px;
}

.right {
  width: 80%;
  border-bottom: 1px dashed #868686;
  padding: 5px;
}

.moveItToRight {
  color: rgb(168, 168, 168);
  font-style: italic;
}

.tagList,
.tags {
  display: inline-block;
}

.pushed {
  background-color: #64b3b9;
}

.ui.selection.dropdown {
  padding: 0px;
}

.tagButtonToggle {
  /* float: left; */
}

/* sidebar */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s;
}

.wpis-title a {
  text-decoration: none;
  color: #4c3e50;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.editButton {
  float: right;
  margin-right: 5%;
}

.smallbutton {
  padding: 5px;
  margin: 2px;
}

.rightText {
  text-align: right;
}

.rotate {
  transform: rotate(180deg);
}

.upToDateComment {
  font-style: italic;
  color: #8b8b8b;
  font-weight: 10;
}

.column7 {
  width: 7%;
}

.column10 {
  width: 9%;
}

.column43 {
  width: 42%;
}

.column20 {
  width: 15%;
}

.tooltip-inner {
  background-color: black;
  min-width: 120px;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  font-family: Georgia;
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  width: 52%;
}

.right-margin {
  padding-right: 120px !important;
}

.wider {
  min-width: 250px !important;
  background-color: rgb(121, 121, 121) !important;
}

@supports (-webkit-appearance: none) {
  .overviewSelect {
    min-height: 30px !important;
    padding-bottom: 0px !important;
    height: 37px;
    text-overflow: ellipsis !important;
  }
}

.overviewSelect .text {
  height: 37px;
  text-overflow: ellipsis !important;
  overflow: hidden;
}

/* _:-moz-tree-row(hover),
.selector {
  .overviewSelect {
    padding-bottom: 0px !important;
    min-height: 30px !important;
    height: 34px;
  }
} */

/* new table */

.drugtable th,
.drugtable td {
  padding: 5px;
}

.JJBK2 {
  width: 100%;
  display: inline-grid;
  grid-template-columns: 2fr 7fr 5fr;
  /* align-items: center; */
  justify-items: start;
}

.goCenter {
  justify-self: end;
}

table.zalecenia {
  /* border: 1px solid #000000; */
  width: 100%;
  text-align: left;
  border-spacing: 0px;
}

table.zalecenia td,
table.zalecenia th {
  border: 0.5px solid #aaaaaa !important;
  padding: 3px 3px;
  min-height: 16px !important;
}

table.zalecenia tbody td {
  padding-left: 10px;
  background-color: white !important;
}

table.dataTable table.zalecenia thead {
  background-color: #dddddd !important;
  color: black;
}

table.zalecenia thead th {
  /* font-size: 12px; */
  font-weight: bold;
}

.col5 {
  width: 5%;
  text-align: center;
}

.LBZcheckbox {
  display: grid;
  width: fit-content;
  grid-template-columns: auto auto auto;
  grid-gap: 15px;
  padding: 10px;
  align-items: center;
}

input[type="checkbox"] {
  transform: scale(1.5);
}

.expertComment {
  display: grid;
  grid-template-columns: 5fr 1fr;
  align-items: center;
}

.justify {
  text-align: justify;
  text-justify: inter-word;
}

.link:hover {
  cursor: pointer;
  color: #6593c7;
  text-decoration: underline;
  /*color: #004b8b;*/
}

.link {
  color: black;
  text-decoration: none;
}

.grid {
  width:85%;
  height: 40px;
  display: grid;
  /* grid-template-columns: 3fr 3fr 2fr 1fr; */
  grid-template-columns: auto auto auto auto auto auto auto;
  grid-template-rows: auto auto;
  grid-column-gap: 8px;
}

.viewTable tr td:first-child {
  background-color: #abc8eec2 ;
}

.rowChoice {
  cursor: pointer;
}

textarea {
  font-family: inherit;
}

.notFF {
  height: 90% !important;
}

.iconDelete:hover {
  color: rgb(151, 62, 62);
  transition-duration: 1s;
  transform: rotate(180deg);
}

.border.ui.selection.dropdown {
  border: solid 2px #004b8b;
}

.border.ui.selection.dropdown:hover {
  border: solid 2px #004b8b;
}
pre {
  overflow-x: auto;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}
</style>
